module.exports = __webpack_public_path__ + "static/media/portfolio-embrace.9c0ba78d.png";